import { render, staticRenderFns } from "./ModalSelecaoTemplates.vue?vue&type=template&id=0e0aae02&scoped=true"
import script from "./ModalSelecaoTemplates.vue?vue&type=script&lang=js"
export * from "./ModalSelecaoTemplates.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecaoTemplates.vue?vue&type=style&index=0&id=0e0aae02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0aae02",
  null
  
)

export default component.exports